import { render, staticRenderFns } from "./EmailLangSelect.vue?vue&type=template&id=e1260d98&scoped=true&"
import script from "./EmailLangSelect.vue?vue&type=script&lang=js&"
export * from "./EmailLangSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1260d98",
  null
  
)

export default component.exports